module.exports = __webpack_public_path__ + "img/uber_btn.df29fecf.png";